import { useEffect, useState } from 'react';
import { useFirebaseProviders } from 'modules/Firebase/FirebaseProvider';

export default function useGalleryData() {
    const { storage } = useFirebaseProviders();
    const imgGalleryRef = storage.child('img/gallery');

    const [data, setData] = useState([]);
    const [error, setError] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        imgGalleryRef
            .list()
            .then(imgData => Promise.all(imgData.items.map(item => item.getDownloadURL())))
            .then(photoUrls =>
                setData(
                    photoUrls.map((src, i) => {
                        const ratio = ratios[i.toString().slice(-1)];
                        return { src, ...ratio };
                    })
                )
            )
            .catch(setError)
            .finally(() => setLoading(false));
        // eslint-disable-next-line
    }, []);

    return [data, loading, error];
}

const ratios = [
    {
        width: 4,
        height: 3,
    },
    {
        width: 1,
        height: 1,
    },
    {
        width: 3,
        height: 4,
    },
    {
        width: 3,
        height: 4,
    },
    {
        width: 3,
        height: 4,
    },
    {
        width: 4,
        height: 3,
    },
    {
        width: 3,
        height: 4,
    },
    {
        width: 4,
        height: 3,
    },
    {
        width: 4,
        height: 3,
    },
    {
        width: 3,
        height: 4,
    },
    {
        width: 4,
        height: 3,
    },
    {
        width: 4,
        height: 3,
    },
    {
        width: 4,
        height: 3,
    },
    {
        width: 4,
        height: 3,
    },
    {
        width: 4,
        height: 3,
    },
    {
        width: 4,
        height: 3,
    },
];
